<template>
  <div>
    <div class="animates-items mb16" v-if="icon">
      <img-icon-upload
          class="mb16"
          :imgSrc.sync="icon.src"
          :iconType.sync="icon.type"
          :iconColor.sync="icon.color"
          :showDel="false"
      />
      <div class="verticallyCenter mb16" v-if="icon.type == 'icon'">
        <span class="mr16 fs14">颜色</span>
        <cx-color-picker class="flex1" :isThemeColor.sync="icon.colorIsThemeColor" :colorArr.sync="icon.color">
        </cx-color-picker>
      </div>
    </div>
    <div class="animates-items">
      <slider-and-input
          class="mb16"
          inputWidth="small"
          inputHeight="small"
          :value.sync="animateDataVal.animateDuration"
          title="持续"
          titlePosition="allInOneLine"
          :sliderMax="10000"
          suffix="ms"
      />
      <slider-and-input
          class="mb16"
          inputWidth="small"
          inputHeight="small"
          :value.sync="animateDataVal.animateDelay"
          title="延迟"
          titlePosition="allInOneLine"
          :sliderMax="10000"
          suffix="ms"
      />
      <div class="verticallyCenter">
        <div class="mr16">触发</div>
        <div class="content">
          <el-radio-group v-model="animateDataVal.animationIterationCount">
            <el-radio
                v-for="(option, index) in triggerstyles.list"
                :key="index"
                :label="option.value"
                :disabled="option.disabled"
            >{{ option.title }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "border-setting",
  components: {},
  props: {
    animateData: {
      type: Object
    },
    options: {
      type: Object
    },
    responseRectIds:{
      type:Array
    }
  },
  data() {
    return {
      fontWeightList: [
        {
          title: "细体",
          value: 200
        },
        {
          title: "常规体",
          value: 400
        },
        {
          title: "粗体",
          value: 700
        },
        {
          title: "加粗体",
          value: 900
        }
      ],
      triggerstyles: {
        type: "触发次数",
        checked: "单次触发",
        list: [
          {
            value: 1,
            disabled: false,
            title: "单次触发"
          },
          {
            value: 2,
            disabled: false,
            title: "多次触发"
          }
        ]
      }
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    animateDataVal: {
      get() {
        return this.animateData
      },
      set(newVal) {
        this.$emit("update:animateData", newVal)
      }
    },
    icon:{
      get() {
        return this.animateDataVal.icon
      },
      set(newVal) {
        this.animateDataVal.icon = newVal
      }
    }
  },
  mounted() {},
  methods: {
    getIconStyle() {
      let triggerType = this.animateDataVal.triggerType
      let iconSrcType = triggerType === 'hover'? 1:2
      let color = this.animateDataVal.icon.color.color ? this.animateDataVal.icon.color.color : this.animateDataVal.icon.color
      this.animateDataVal.variable[`${triggerType}IconSrcType`] = `options_iconSrcType_${iconSrcType}`
      this.animateDataVal.variable[`${triggerType}IconColor`] =  this.animateDataVal.icon.colorIsThemeColor ? "var_IconColor_page.themeColor" : color
      // 修改options 里面的属性
      this.responseRectIds.forEach(ids=>{
        this.$changeOptionsEV(this.animateDataVal.icon.src,`${triggerType}IconSrc`, false,null,ids)
        this.$changeOptionsEV(iconSrcType,`${triggerType}IconSrcType`, false,null,ids)
      })
    }
  },
  beforeDestroy() {
    // 改变颜色的时候未触发 set  所以在关闭前重新计算一次
    this.getIconStyle()
  }
}
</script>

<style lang="scss" scoped></style>
